import React, { useEffect } from 'react';
import styles from '../styles/HotelPlansSearch.module.scss';
import { getImage } from '../../utils/pathHelper';
import checkGreenSvg from '../images/checkGreen.svg';
import { SearchParams } from '../types';
import { isAfter, isSameDay, startOfDay } from 'date-fns';
import i18n from '../../i18n';
import { formatDateWithDayOfWeek } from "../../utils/dateHelper";

interface IModal {
  isShown: boolean;
  whiteMode?: boolean;
  handleClose: () => void;
  title?: string;
  selectedPackageDetails?: string;
  peopleCountDisplay?: string;
  checkinDatesDisplay?: string;
  query?: SearchParams;
  freeCancellable?: boolean;
  freeCancellationDeadline?: Date;
}

const Modal: React.FC<IModal> = ({ isShown, whiteMode, handleClose, title, peopleCountDisplay, checkinDatesDisplay, children, freeCancellable, freeCancellationDeadline, query }) => {

  useEffect(() => {
    if (isShown) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isShown]);

  function handleBackdropClick(event: React.MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.currentTarget === event.target) {
      handleClose();
    }
  }

  return (
    <div className={`${styles.modal} ${isShown && styles.active} ${whiteMode && styles.whiteMode}`} onClick={handleBackdropClick}>
      <div className={`${styles.inner} modal-content rounded-xl border-0`}>
        <div className={`${styles.modalHeader} ${!whiteMode && 'light-shadow-box'} bg-white modal-header rounded-xl py-4 px-2 position-relative`}>
          <div className="text-center flex-grow-1">
            <h6 className="modalTitle mb-1">{title}</h6>
            <span className="text-muted">
              <span className="font-weight-bold">{checkinDatesDisplay}</span>
              {checkinDatesDisplay && peopleCountDisplay && ' | '}
              <span className="font-weight-bold">{peopleCountDisplay}</span>
            </span>
            { (freeCancellable && (isSameDay(freeCancellationDeadline, new Date()) || isAfter(freeCancellationDeadline, new Date()))) && (
              <span className={styles.modalCancelNote}>
                <img src={getImage(checkGreenSvg)} alt='' className="mr-1" />
                {i18n.t('stay_packages.shared.free_cancellation_until_x_days_before', { x: formatDateWithDayOfWeek(freeCancellationDeadline) })}
              </span>
            )}
          </div>
          <button
            className="close modalCloseButton"
            aria-label="Close"
            onClick={handleClose}
            style={{ position: 'absolute', right: '16px' }}
          >
            <span aria-hidden="true">
              <i className="fas fa-times"></i>
            </span>
          </button>
        </div>
        <div className={`${styles.modalBody} modal-body`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
